/**
 * Shared session logger configuration (PPT + Excel).
 */
function isProductionBuild() {
    try {
        return (typeof CAROUSEL_PRODUCTION !== "undefined" && CAROUSEL_PRODUCTION === true);
    }
    catch {
        return false;
    }
}
export const DEFAULT_CONFIG = {
    enabled: !isProductionBuild(),
    serverUrl: "http://127.0.0.1:5001",
    batchIntervalMs: 2000,
    batchSize: 10,
    captureSlideImages: true,
    useLocalStorageBackup: true,
    maxLocalStorageSessions: 20,
    localStoragePrefix: "carousel_ai_session_",
};
let currentConfig = { ...DEFAULT_CONFIG };
export function getLoggingConfig() {
    return currentConfig;
}
export function setLoggingConfig(config) {
    currentConfig = { ...currentConfig, ...config };
}
export function isLoggingEnabled() {
    return currentConfig.enabled;
}
export function setLoggingEnabled(enabled) {
    currentConfig.enabled = enabled;
}
